import { UAParser } from 'ua-parser-js';
import type { TabletOrMobileOrDesktop } from './types';

export const getDeviceTypeFromUserAgentString = (userAgentString = ''): TabletOrMobileOrDesktop => {
  if (userAgentString === '') {
    return 'mobile';
  }

  const parser = new UAParser(userAgentString);

  const parsedType = parser.getDevice().type;

  if (parsedType === undefined) {
    return 'desktop';
  }

  if (parsedType === 'mobile') {
    return 'mobile';
  }

  if (parsedType === 'tablet') {
    return 'tablet';
  }

  return 'mobile';
};
